import fetch from 'isomorphic-fetch';
import * as ActionType from './types/ExternalActionTypes';

export const updateExternal = data => ({
  type: ActionType.UPDATE_EXTERNAL,
  payload: data
});

export const placedOrder = data => ({
  type: ActionType.PLACED_ORDER,
  payload: data
});

export const confirmedOrder = data => ({
  type: ActionType.CONFIRMED_ORDER,
  payload: data
});

export const cancelledOrder = () => ({
  type: ActionType.CANCELLED_ORDER
});

export const resetExternal = () => ({
  type: ActionType.RESET
});

export function placeOrder(externalPurchaseRequest) {
  return dispatch => (
    fetch('/api/v0/external-order/place', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(externalPurchaseRequest)
    })
      .then(response => response.json())
      .then(json => dispatch(placedOrder(json)))
  );
}

export function confirmOrder(splitOrderId, token, confirmRequest) {
  return dispatch => (
    fetch(`/api/v0/external-order/confirm?splitOrderId=${splitOrderId}&token=${token}`, {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(confirmRequest)
    })
      .then(response => response.json())
      .then(json => dispatch(confirmedOrder(json)))
  );
}

export function cancelOrder(splitOrderId, token, reason) {
  return dispatch => (
    fetch(`/api/v0/external-order/cancel?splitOrderId=${splitOrderId}&token=${token}&reason=${reason}`,
      {
        credentials: 'same-origin',
        method: 'POST'
      })
        .then(response => response.json())
        .then(() => dispatch(cancelledOrder()))
  );
}



// WEBPACK FOOTER //
// ./src/actions/ExternalActions.js